import { render, staticRenderFns } from "./DatiCreaPolizze.vue?vue&type=template&id=ec9d0bac&scoped=true&"
import script from "./DatiCreaPolizze.vue?vue&type=script&lang=js&"
export * from "./DatiCreaPolizze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9d0bac",
  null
  
)

export default component.exports
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerHourglass,QDialog,QCard,QCardSection,QCardActions,QBtn});qInstall(component, 'directives', {ClosePopup});
